import { createApiClient } from '@/api/client';
import type { FuneralHomeDTO, FuneralHomeSettingsDTO } from '@/types/funeral-home';

export async function getFuneralHomeSettings(funeralHomeId: number): Promise<FuneralHomeSettingsDTO> {
    const api = createApiClient();
    const response = await api.get(`/funeralhomes/settings/${funeralHomeId}`);

    return response.data as FuneralHomeSettingsDTO;
}

export async function getFuneralHome(funeralHomeId: number): Promise<FuneralHomeDTO> {
    const api = createApiClient();
    const response = await api.get(`/funeralhomes/${funeralHomeId}`);
    const result = response.data as { funeralHome?: FuneralHomeDTO };

    return result.funeralHome ?? {};
}

export default function FuneralHomeService() {
    return {
        getSettingsAdmin: (funeralHomeId: number) => createApiClient().get(`/funeralhomes/settings/admin/${funeralHomeId}`),
        getSettings: (funeralHomeId: number) => createApiClient().get(`/funeralhomes/settings/${funeralHomeId}`),
        updateSettingsAdmin: (data: unknown) => createApiClient().put('/funeralhomes/settings/admin', data),
        updateSettings: (data: unknown) => createApiClient().put('/funeralhomes/settings', data),
        getMusicEmbedMode: (funeralHomeId: number) => createApiClient().get(`/funeralhomes/music-embed-mode/${funeralHomeId}`),
        updateMusicEmbedMode: (funeralHomeId: number, mode: number | string) => createApiClient().put(`/funeralhomes/music-embed-mode/${funeralHomeId}`, null, { params: { mode } }),
        getBetaAccess: (fhId: number) => createApiClient().get(`/funeralhomes/settings/beta/${fhId}`),
        deleteTributeEndingVideo: (funeralHomeId: number) => createApiClient().delete(`/funeralhomes/tribute-ending-video/${funeralHomeId}`),
        getTributeSettings: (funeralHomeId: number) => createApiClient().get(`/funeralhomes/settings/tribute/${funeralHomeId}`),
        updateTributeSettings: (funeralHomeId: number, data: unknown) => createApiClient().put(`/funeralhomes/settings/tribute/${funeralHomeId}`, data),
        getFuneralHome: (funeralHomeId: number) => createApiClient().get(`/funeralhomes/${funeralHomeId}`),
        revokeTukiosApiKey: (funeralHomeId: number) => createApiClient().post(`/funeralhomes/api/tukios/revoke/${funeralHomeId}`),
        revokeMemoryShareApiKey: (funeralHomeId: number) => createApiClient().post(`/funeralhomes/api/revoke/${funeralHomeId}`),
        generateTukiosApiKey: (funeralHomeId: number) => createApiClient().post(`/funeralhomes/api/tukios/generate/${funeralHomeId}`),
        generateMemoryShareApiKey: (funeralHomeId: number) => createApiClient().post(`/funeralhomes/api/generate/${funeralHomeId}`),
        getTukiosApiKey: (funeralHomeId: number) => createApiClient().get(`/funeralhomes/api/tukios/get/${funeralHomeId}`),
        getMemoryShareApiKey: (funeralHomeId: number) => createApiClient().get(`/funeralhomes/api/get/${funeralHomeId}`),
        updatePassareImportSetting: (funeralHomeId: number, importPassareEvents: boolean) => createApiClient().post('/Integration/Passare/import-settings', { funeralHomeId, importPassareEvents }),
        getUsers: (funeralHomeId: number, quick = true) => createApiClient().get(`/Users?funeralHomeId=${funeralHomeId}&quick=${quick}`),
    };
}
